module.exports = __webpack_public_path__ + "img/zone200300.d54de1e0.png";